export default "__VITE_ASSET__BlpAFc2A__"